import React, {useState} from 'react';
import axios from "axios";
import qs from 'qs';
import moment from "moment";

export const useTemplates = (props) => {
  const displayEditContentButton = props && props.form ? props.form.displayEditContentButton : false;
  const canCustomize = props && props.form ? props.form.customize : false;
  const [modalShow, setModalShow] = useState(false);
  const [savingTemplate, setSavingTemplate] = useState(false);
  const [lastPublishedAt, setLastPublishedAt] = useState(props && props.form.lastPublishedAt ? props.form.lastPublishedAt : '');

  let _content = '';
  let {nineToKnowTemplateContent, nineToKnowActiveTemplate} = props.form;
  const [activeTemplate, setActiveTemplate] = useState(nineToKnowActiveTemplate !== 'undefined' ? nineToKnowActiveTemplate : '1');
  // console.log('nineToKnowTemplateContent', nineToKnowTemplateContent.content)
  if (nineToKnowTemplateContent && typeof nineToKnowTemplateContent === 'object' && nineToKnowTemplateContent.content) {

    _content = nineToKnowTemplateContent.content;
  }
  const defaultContent = `<br/>Welcome to 9 To Know, a quick and easy way to take a look into your financial future.
              <br/><br/>
              Here you can obtain a complimentary basic financial analysis by entering 9 pieces of contact and financial information.
              <br/><br/>
              This analysis can help determine if you are on track for a successful retirement or if you may come up short. If you find the analysis doesn’t match your desired results, your advisor could provide recommendations that may help you attain your financial goals and improve your retirement picture.<br/>`
  if (!_content || _content === '') {
    _content = defaultContent;
  }
  const [content, setContent] = useState(_content);
  const defaultImage1 = 'https://rs-tg-images.s3.us-east-2.amazonaws.com/finance_glasses.jpeg';
  const defaultImage2 = 'https://rs-tg-images.s3.us-east-2.amazonaws.com/financial_freedom.jpeg'
  let im1 = defaultImage1;
  let im2 = defaultImage2;
  if (nineToKnowTemplateContent && typeof nineToKnowTemplateContent === 'object' && nineToKnowTemplateContent.image1) {
    im1 = nineToKnowTemplateContent.image1;
  }
  if (nineToKnowTemplateContent && typeof nineToKnowTemplateContent === 'object' && nineToKnowTemplateContent.image2) {
    im2 = nineToKnowTemplateContent.image2;
  }
  const [image1, setImage1] = useState(im1);
  const [image2, setImage2] = useState(im2);
  const [selectedFile1, setSelectedFile1] = useState(null);
  const [selectedFile2, setSelectedFile2] = useState(null);
  const [preview1, setPreview1] = useState(null);
  const [preview2, setPreview2] = useState(null);
  const fileSelectedHandler1 = (event) => {
    const file = event.target.files[0];
    setSelectedFile1(file);

    // Preview the selected image
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview1(reader.result);
    };
    reader.readAsDataURL(file);
  };
  const fileSelectedHandler2 = (event) => {
    const file = event.target.files[0];
    setSelectedFile2(file);

    // Preview the selected image
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview2(reader.result);
    };
    reader.readAsDataURL(file);
  };
  const imageUploadHandler = async (selectedFile) => {
    return new Promise(resolve => {
      // console.log('uploading image1');
      const formData = new FormData();
      formData.append('files', selectedFile);

      axios.post('/92know/admin/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
           .then(response => {
             console.log(response);
             if (response && response.data && !response.data.error && response.data.url) {
               const url = response.data.url;
               resolve(url)
             } else {
               resolve('');
             }
           })
           .catch(error => {
             console.error(error);
             resolve('');
           });
    })
  }
  const applyTemplateCustomizations = async () => {
    let image1Url = image1;
    let image2Url = image2;
    setSavingTemplate(true);
    if (selectedFile1) {
      image1Url = await imageUploadHandler(selectedFile1);
      setImage1(image1Url)
    }
    if (selectedFile2) {
      image2Url = await imageUploadHandler(selectedFile2);
      setImage2(image2Url)
    }
    // console.log('images url', image1Url, image2Url);
    axios.post('/92know/admin/template/content', qs.stringify({
      template: activeTemplate,
      content,
      image1: image1Url,
      image2: image2Url
    }), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
         .then(response => {
           setSavingTemplate(false);
           console.log(response);
           if (response && response.data && response.data.success) {
             toggleModal()
           }
         })
         .catch(error => {
           setSavingTemplate(false);
           console.error(error);
         });
  }
  const toggleModal = () => {
    setModalShow(!modalShow);
  }
  const customizeTextHandler = (c) => {
    // console.log('customizeTextHandler', c)
    setContent(c);
  }
  const setTemplateAsActive = (activaTemplateId) => {
    setActiveTemplate(activaTemplateId);
  }
  const publishActiveTemplate = () => {
    const publishDate = moment().format('MM/DD/YYYY hh:mma');
    axios.post('/92know/admin/template/setDefault', qs.stringify({activeTemplate: activeTemplate, publishDate}), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
         .then(response => {
           nineToKnowActiveTemplate = activeTemplate;
           props.setCustomMessage({
             messageTitle: 'Template Published',
             messageBody: 'Template has been successfully published. The published template will now be displayed to all prospects.',
           })
           props.setShowMessage(true);
           const lpa = lastPublishedAt
           lpa[activeTemplate] = publishDate
           setLastPublishedAt(lpa)
         })
         .catch(error => {
         });
  }
  const resetTemplateHandler = () => {
    if (activeTemplate === '0') {
      axios.post('/92know/admin/content?reset=true', qs.stringify({
        type: 'topMid',
        content: defaultContent
      }), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(() => {
      }).catch(error => {
      }).finally(() => {
        window.location.reload();
      });
    } else {
      customizeTextHandler(defaultContent);
      setImage1(defaultImage1);
      setImage2(defaultImage2);
      axios.post('/92know/admin/template/content', qs.stringify({
        image1: defaultImage1,
        image2: defaultImage2,
        content: defaultContent
      }), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }).then(() => {
      }).catch(error => {
      }).finally(() => setModalShow(!modalShow));
    }
  }
  return {
    nineToKnowActiveTemplate,
    displayEditContentButton,
    canCustomize,
    activeTemplate,
    setActiveTemplate,
    setTemplateAsActive,
    modalShow,
    setModalShow,
    content,
    image1,
    image2,
    toggleModal,
    customizeTextHandler,
    fileSelectedHandler1,
    fileSelectedHandler2,
    setSelectedFile1,
    setSelectedFile2,
    imageUploadHandler,
    preview1,
    preview2,
    applyTemplateCustomizations,
    savingTemplate,
    resetTemplateHandler,
    publishActiveTemplate,
    lastPublishedAt
  }
}
